import React from 'react'
import { Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {useNavigate} from 'react-router-dom'
import RemoveCookie from '../hooks/removeCookie'
import ClearToken from '../hooks/clearToken';
import api from '../api/authApi'
import useAuth from '../hooks/useAuth'


export default function Confirm({log,setLog, message}) {
  const navigate=useNavigate()
  const remove=ClearToken()
  const {user}=useAuth();
  return (
     <Dialog
        open={log}
        onClose={()=>setLog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      
      >
        <DialogTitle id="alert-dialog-title">
          {message}
        </DialogTitle>
        <DialogContent>
        </DialogContent>
        <DialogActions>
            <ButtonGroup
                disableElevation
                variant="contained"
                aria-label="Disabled elevation buttons"
                sx={{
                  bgcolor:'white'
                }}
              >
                <Button disableElevation
                onClick={()=>{
                  api
                  .patch("/logout", {token:user.refreshToken})
                  .then(() => {
                    setLog(false);
                    remove();
                    RemoveCookie('auth');
                    navigate('/login')
                  })}}
                sx={{
                  bgcolor:'secondary.dark',
                  "&:hover":{
                    bgcolor:'secondary.main'
                  }
                }}>Yes</Button>
                <Button 
                onClick={()=>setLog(false)}
                sx={{
                bgcolor:'gray',
                "&:hover":{
                    bgcolor:'darkGray'
                  }
              }} >Cancel</Button>
          </ButtonGroup>
        </DialogActions>
      </Dialog>
  )
}
